import type { PreloadedQuery } from 'react-relay';
import type { RouteResource } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import QUERY, {
	type JiraSpaPageContainerQuery,
} from '@jira/platform__page-container-v2/src/common/ui/page-container/__generated__/JiraSpaPageContainerQuery.graphql';

export const jiraSpaPageContainerResource: RouteResource<
	PreloadedQuery<JiraSpaPageContainerQuery>
> = createRelayResource<JiraSpaPageContainerQuery>({
	type: 'JIRA_SPA_STATE_RELAY',
	getQuery: (_, context) => {
		const cloudId = context?.tenantContext?.cloudId || '';
		return {
			parameters: QUERY,
			variables: {
				cloudId,
			},
			options: { fetchPolicy: 'store-or-network' as const },
		};
	},
	captureErrors: true,
	isCritical: true,
});
